/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {OfferTemplateDto} from "./offerTemplateDto.zod";
import {PaginationMeta2} from "./paginationMeta2.zod";

export const PaginatedOfferTemplateDto = zod.object({
  items: zod.array(OfferTemplateDto),
  meta: PaginationMeta2,
});

export type PaginatedOfferTemplateDto = zod.input<typeof PaginatedOfferTemplateDto>;
export type PaginatedOfferTemplateDtoOutput = zod.output<typeof PaginatedOfferTemplateDto>;
